import { Component, OnInit } from '@angular/core';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { Role } from '../../../../roles/models/role.model';
import { UserService } from '../../../../services/user.service';
import { RoleEditComponent } from '../role-edit/role-edit.component';
import { RolesService } from '../../../../services/roles.service';
import { UserDto, User, UserAssignRoles } from '../../../../models/user.model';
import { UserEditComponent } from '../user-edit/user-edit.component';
import { UserAssignRolesComponent } from '../user-assign-roles/user-assign-roles.component';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
  dataSource: MatTableDataSource<UserDto>;
  displayedColumns = ['actions','userName','email','name','firstName','familyName','fullName'];
  isEdit:Boolean = false;

  constructor(
    private roleService:RolesService,
    public userService:UserService,
    public dialog: MatDialog    
  ) { }
  loadData(){
    this.userService.getAll().subscribe(users=>{
      this.dataSource = new MatTableDataSource(users);
    })        
  }
  ngOnInit() {
    this.loadData();    
  }
  userId:string = null;
  onEdit(user:UserDto): void {    
    this.isEdit = true;    
    this.userId = user.id;
    
    this.userService.get(user.id).subscribe(user=>{      
      let userModel = new User();
      userModel.userName = user.userName;
      userModel.code = user.code;
      userModel.email = user.email;
      userModel.familyName = user.familyName;
      userModel.firstName = user.firstName;
      userModel.fullName = user.fullName;
      userModel.idAccount = user.idAccount;
      userModel.name = user.name;
      userModel.storageType = user.storageType;      


      const dialogRef = this.dialog.open(UserEditComponent, {
        disableClose:true,
        width: '250px',
        data: userModel
      });
  
      dialogRef.afterClosed().subscribe(result => {
        let user:User = result;
        if(this.isEdit && user && user.email){
          if(this.userId){
            this.userService.update(this.userId,user).subscribe(()=>{
              this.loadData();
            });
          }
        }
      });      
    });

        
  }
  onAdd(): void {
    this.isEdit = false;
    const dialogRef = this.dialog.open(UserEditComponent, {
      disableClose:true,
      width: '250px',
      data: new User()
    });

    dialogRef.afterClosed().subscribe(result => {
      let user:User = result;
      if(!(this.isEdit) && user && user.email){
        this.userService.register(user).subscribe(()=>{
          this.loadData();
        });
      }
    });    
  }    
  assignRoles(user:UserDto): void {    
    const dialogRef = this.dialog.open(UserAssignRolesComponent, {
      disableClose:true,
      width: '250px',
      data: {
        user:user,
        roles:user.roles
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      let assignRoles:UserAssignRoles = result;
      if(assignRoles){
        this.roleService.Assign(assignRoles.user.userName,assignRoles.roles).subscribe();
      }
    });    
  }    
}
